import HotelList from './HotelList';

export default HotelList;
